import axiosInstance from '@/plugins/api/axiosInstance';

export default function billing() {
    return {
        verifyCheckout
    };

    function verifyCheckout(payload) {
        return axiosInstance.post('billing/checkout/verify', payload);
    }
}
